/* eslint-disable */
import React from 'react';
import logo from '../../images/SideBarImg/Enabling_white.png';
import financeLogo from '../../images/SideBarImg/Finanace_white.png';
import processLogo from '../../images/SideBarImg/PEQ_white.png';
import talentLogo from '../../images/SideBarImg/Talent_white.png';
import transitionLogo from '../../images/SideBarImg/Transition_white.png';
import hsnicon from '../HSN.png';

export const EnablingLogoIcon = ({ size = 24 }) => (
  <img src={logo} alt="Enabling Main Logo" style={{ width: size, height: size }} />
);

export const HSNIcon = ({ size = 24 }) => (
  <img src={hsnicon} alt="HSN Main Logo" style={{ width: size, height: size }} />
);


export const FinanceLogoIcon = ({ size = 24 }) => (
  <img src={financeLogo} alt="Finance Logo" style={{ width: size, height: size }} />
);

export const ProcessLogoIcon = ({ size = 24 }) => (
  <img src={processLogo} alt="Process & Excellence Quality Logo" style={{ width: size, height: size }} />
);

export const QualityLogoIcon = ({ size = 24 }) => (
  <img src={processLogo} alt="Quality Logo" style={{ width: size, height: size }} />
);

export const TalentLogoIcon = ({ size = 24 }) => (
  <img src={talentLogo} alt="Talent Logo" style={{ width: size, height: size }} />
);

export const TransitionLogoIcon = ({ size = 24 }) => (
  <img src={transitionLogo} alt="Transition Logo" style={{ width: size, height: size }} />
);
